import axiosService from "services/axios.service";

export const importTracks = async (data: any) => {
  try {
    const response = await axiosService.post(
      "/v1/admin/tracks/bulk/create",
      data
    );
    return response?.data.data;
  } catch (error) {
    console.log(error);
  }
};

export const importUsers = async (data: any) => {
  try {
    const response = await axiosService.post(
      "/v1/admin/users/bulk/create",
      data
    );
    return response?.data.data;
  } catch (error) {
    console.log(error);
  }
};

export const importTags = async (data: any) => {
  try {
    const response = await axiosService.post(
      "/v1/admin/tags/bulk/create",
      data
    );
    return response?.data.data;
  } catch (error) {
    console.log(error);
  }
};

export const importGenres = async (data: any) => {
  try {
    const response = await axiosService.post(
      "/v1/admin/genres/bulk/create",
      data
    );
    return response?.data.data;
  } catch (error) {
    console.log(error);
  }
};

export const testApi = async () => {
  try {
    const response = await axiosService.get(
      "/v1/admin/tracks/bulk/create/test"
    );
    return response?.data.data;
  } catch (error) {
    console.log(error);
  }
};
